import { ConnectionStatus } from "../model/ConnectionStatus";
import { IConnectionStatusService } from "../IConnectionStatusService";
import { Observable } from "rxjs";

export abstract class ConnectionStatusPromiseService implements IConnectionStatusService {
  abstract getConnectionEvents(): Observable<ConnectionStatus>;
  abstract isConnectionActive(): Promise<ConnectionStatus>;
  // abstract sendPing():void;
}
